import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import Logo from "../../../assets/images/logo.png";
import Arrow from "../../../assets/images/arrow.png";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import "bootstrap/dist/css/bootstrap.min.css";
import "../login.css";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetLogin, selectLogin } from "../../../features/login/loginSlice";
import { GetCaptcha, selectCaptcha } from "../../../features/login/captchSlice";
import swal from "sweetalert";
import { currentUserId } from "../../../features/localStorage";
import { dev } from "../../../features/network/ApiCall";
import EmptyRow from "../../../components/emptyRow/EmptyRow";

var md5 = require("md5");
function RegisteredUser() {
  const logIn = useAppSelector(selectLogin);
  const getCaptcha = useAppSelector(selectCaptcha);
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [username, setUserName] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [captcha, setCaptcha] = useState<any>();
  const [remember, setRemember] = useState<string>("no");
  const [isPassword, setIspassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const domainName = localStorage.getItem("domainName") ;
  const domainNameList: any = domainName;
  const selectedDomain = JSON.parse(domainNameList); 

  const selectedId = localStorage.getItem("selectedId") ;
  const selectedIdList: any = selectedId;
  const selectedDomainId = JSON.parse(selectedIdList); 

  

  const Username = (event: React.ChangeEvent<HTMLInputElement>) =>
    setUserName(event.target.value);
  const Password = (event: React.ChangeEvent<HTMLInputElement>) =>
    setPassword(event.target.value);
  const Captcha = (event: React.ChangeEvent<HTMLInputElement>) =>
    setCaptcha(parseInt(event.target.value));
  const Remember = () =>
    remember == "no" ? setRemember("yes") : setRemember("no");

  useEffect(() => {
            localStorage.removeItem("userDetails");
            localStorage.removeItem("otp");
            localStorage.removeItem("forgetpass");
            localStorage.removeItem("isSSO");
            localStorage.removeItem("URP");
            localStorage.removeItem("store");
            localStorage.removeItem('isSession');
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("userPhotoDetails");
    async function fetchCaptchaDetails() {
      let sample = await dispatch(GetCaptcha());
    }
    fetchCaptchaDetails();
    //console.log(selectedDomain,"selectedDomain")
  }, []);
  const userDetails: any = localStorage.getItem("userDetails");
  let userDetailsJson = JSON.parse(userDetails);

  const [isLogin, setIsLogin] = useState(
    userDetailsJson?.accessToken ? userDetailsJson.accessToken : undefined
  );
 // console.log(selectedDomain.split(","))
  const EmailCheck = async (event: any) => {
    var userDomain=username?.substring(username?.lastIndexOf("@") +1)
    event.preventDefault();
    var domainArr=selectedDomain?.split(",")
    var filteredDomain=domainArr?.filter((item:any) => {
      if (userDomain?.includes(item)) {
        return item
      }
    })
    
    if(filteredDomain==userDomain){
    let data = {
      emailId: username,
      companyId:selectedDomainId
    };
    var axios = require("axios");
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/verify/checkEmail`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response: any) {
       // console.log(JSON.stringify(response.data.emailCheck));
        if (response.data.emailCheck === true) {
          window.location.href = `${process.env.REACT_APP_MFA_LOGIN_URL}`;
          // window.location.href = `${process.env.REACT_APP_URL}/authentication/app/login`;
        }
        if (response.data.IsDomain === true) {
          setIspassword(true);
        }
        if (response.data.IsDomain === false) {
          swal({
            title: "Email id not Registered, Please Register",
            icon: "error",
          }).then(function () {
            window.location.href = `${process.env.REACT_APP_URL}/NewUserRegister`;
          });
        }
      })
      .catch(function (error: any) {
        console.log(error);
        swal(error?.response?.data?.emailCheck, "", "error");
      });
    }else{
      swal(`Enter valid domain name. selected domain name ${selectedDomain} `, "", "error");
    }
  };
  const showEmail = () => {
    setIspassword(false);
  };
  const UserLogin = async (event: any) => {
    //alert("click")
    event.preventDefault();
    //if (getCaptcha.total == captcha) {

    setLoading(true);
    let data = {
      emailId: username,
      password: md5(password),
      captchaId: getCaptcha.id,
      captchaTotal: captcha,
      //password: password,
      //password: password,
      // key:'test'
    };
    var axios = require("axios");
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/register/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response: any) {
        // console.log(JSON.stringify(response.data.data));
        setLoading(false);
        localStorage.setItem("userDetails", JSON.stringify(response.data.data));
        localStorage.setItem("isSSO", JSON.stringify(false));
        if (response.data.data !== null) {
          if (response.data.data.InitialLogin === true) {
            history.push("/ChangePassword");
          } else {
            //history.push("/home");
            localStorage.setItem('isSession', JSON.stringify(true));
            window.location.href = "/home";
          }
        } else {
          history.push("/");
          swal(response.data.error, "error");
        }
      })
      .catch(function (error: any) {
        // alert()
        setLoading(false);
        swal("User Login Failed", "", "error");
        // swal("wrong Captcha!", "error");
        // alert("wrong Captcha!");
        dispatch(GetCaptcha());
      });

    //else {
    //   swal("wrong Captcha!", "error");
    //   // alert("wrong Captcha!");
    //   dispatch(GetCaptcha());
    // }
  };

  const Forgot = () => {
    history.push({
      pathname: `/forgot`,
      state: { id: username },
    });
  };

  return (
    <>
      <Container fluid style={{ height: "auto" }}>
        <Row sm={3}>
          <Col></Col>
          <Col
            className="bg-white tb-mar-mob0-desk48 mx-auto loginshadow"
            xxl={3}
            xs={10}
          >
            <div className="my-5 lr-mar-mob4-desk24">
              <Image
                className="mx-auto d-block"
                style={styles.limg}
                src={Logo}
              />
              <div className="mt-2 mb-3" style={styles.head}>
                Ethics and Governance portal
              </div>
              <Form autoComplete="new-password">
                {isPassword !== true ? (
                  <input
                    className="shadow-none mb-3"
                    style={styles.text1}
                    type="text"
                    placeholder="Please enter your official email id"
                    name={username}
                    onChange={Username}
                    autoComplete="nope"
                    required
                  />
                ) : (
                  <div className="row">
                    <div className="col-sm-12">
                      <label className="mb-3">{username}</label>
                      <label style={styles.text2} onClick={showEmail}>
                        Change Email
                      </label>
                    </div>
                  </div>
                )}
                {isPassword === true ? (
                  <>
                    <input
                      className="shadow-none"
                      style={styles.text1}
                      type="password"
                      autoComplete="nope"
                      placeholder="Password"
                      name={password}
                      onChange={Password}
                      required
                    />
                    <Form.Group className="mb-2" controlId="formBasicCheckbox">
                      <Row>
                        {/* <Col style={{ paddingRight: 0 }}> <Form.Check
                        type="checkbox"
                        id="remember"
                        onChange={Remember}
                      >
                        <Form.Check.Input
                          type={"checkbox"}
                          style={{
                            borderColor: "red",
                            borderRadius: 0,
                            marginRight: "5px",
                          }}
                        />
                        <Form.Check.Label
                          style={{
                            color: "#000",
                            borderColor: "red",
                            fontFamily: "Saira",
                            fontSize: "14px",
                          }}
                        >
                          {"Remember Me"}
                        </Form.Check.Label>
                      </Form.Check>
                     
                    </Col> */}
                        <Col>
                          <a
                            // href="/forgot"
                            className="float-end pt-1"
                            style={styles.text2}
                            onClick={Forgot}
                          >
                            {" "}
                            FORGOT PASSWORD
                          </a>
                        </Col>
                      </Row>
                    </Form.Group>
                    <InputGroup className="mb-3">
                      <Form.Control
                        className="mt-3 border-end-0 shadow-none"
                        style={styles.text1}
                        type="text"
                        placeholder="Captcha calculation"
                        name={captcha}
                        onChange={Captcha}
                        required
                      />
                      <InputGroup.Text
                        className="mt-3"
                        style={styles.capcha}
                        id="basic-addon2"
                      >
                        {getCaptcha?.num1}+{getCaptcha?.num2}
                      </InputGroup.Text>
                    </InputGroup>
                    <Button
                      style={styles.btn1}
                      variant="danger"
                      onClick={UserLogin}
                      type="button"
                    >
                      SUBMIT
                      
                    </Button>
                  </>
                ) : null}

                {isPassword !== true ? (
                  <Button
                    style={styles.btn1}
                    variant="danger"
                    onClick={EmailCheck}
                    type="button"
                  >
                    LOGIN FOR REGISTERED USERS
                  </Button>
                ) : null}

                <EmptyRow />
                <Row>
                  <Col sm={12}>
                    <p style={styles.center}> OR </p>
                  </Col>
                </Row>

                <a href="/NewUserRegister">
                  <Button style={styles.btn1} variant="danger" type="button">
                    NEW USER REGISTRATION
                  </Button>
                </a>

                <EmptyRow />

                {/* <a
                  href={`${process.env.REACT_APP_URL}/authentication/app/login`}
                >
                  <Button style={styles.btn1} variant="danger" type="button">
                    LOGIN WITH SSO
                  </Button>
                </a> */}
                <br />
                <br />
              </Form>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  center:{textAlign: "center",},
  head: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: "500",
    textAlign: "center",
  },
  limg: {
    width: "159px",
    height: "22px",
  },
  img1: {
    width: "24px",
    height: "24px",
  },
  checkb: {
    boxSizing: "border-box",
    boxShadow: "inset 0px 0px 0px 2px red",
  },
  text1: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    borderRadius: "0px",
    border: "solid 1px #e4e4e4",
  },
  text2: {
    float: "right",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "600",
    color: "red",
    textDecoration: "none",
  },
  text3: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    textAlign: "center",
  },
  remember: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    color: "black",
  },
  btn1: {
    width: "100%",
    height: "48px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "600",
    color: "white",
    borderRadius: "0px",
    padding: "15px",
  },
  capcha: {
    fontSize: "14px",
    fontFamily: "Georama-Regular",
    color: "#cdcdcd",
    backgroundColor: "white",
    borderRadius: "0px",
    border: "solid 1px #e4e4e4",
  },
};

export default RegisteredUser;
